// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Ei-z"};